

























import { COLUMNS_NUMBER } from '@/config/app.config'
import { ICategory } from '@/types/category'
import Vue from 'vue'
import Category from './Category.vue'

export default Vue.extend({
    components: {
        Category,
    },
    data() {
        return {
            COLUMNS: COLUMNS_NUMBER,
            firstCol: [] as ICategory[],
            secondCol: [] as ICategory[],
        }
    },
    methods: {
        filteredItems(column: number, columns: number): ICategory[] {
            const categoriesList = this.categories
            const total = categoriesList.length        // How many items
            const gap   = Math.ceil(total / columns)   // 4  How many per col
            let   top   = gap * column                 // 4 , 8  Top of the column
            const bottom = top - gap                   // 0 , 4  Bottom of the column
            top -= 1                                   // 3 , 7  Adjust top back down one

            return categoriesList.filter((item: ICategory) =>
                categoriesList.indexOf(item) >= bottom && categoriesList.indexOf(item) <= top)
        },
    },
    name: 'Description',
    props: [ 'categories' ],
})
